import AssetForm from '../AssetForm/AssetForm';
import { useEffect, useRef, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingBtn from '../../../components/LoadingBtn/LoadingBtn';
import api from '../../../api/Api';

function AssetEdit() {
  const { identy } = useParams();
  const navigate = useNavigate();
  const [asset, setAsset] = useState(null);
  const [loading, setLoading] = useState(false);
  const formRef = useRef();

  useEffect(() => {
    api.get(`/api/assets/${identy}`)
      .then((res) => setAsset(res.data.response))
      .catch(err => console.error(err));
  }, [identy]);

  const handleEdit = (updatedAsset) => {
    setLoading(true);
    api.put(`/api/assets/${identy}`, updatedAsset)
      .then(() => {
        toast.success("Asset Edit Successfully");
        setTimeout(() => navigate(`/assets/${identy}`), 1000);
      })
      .catch(err => console.error(err))
      .finally(() => setTimeout(() => setLoading(false), 1000));
  };

  if (!asset) return <p>Loading...</p>;

  return (
    <>
      {/* <ToastContainer position="bottom-right" autoClose={3000} /> */}
      <div className='d-flex justify-content-between align-items-center mx-3'>
        <Link to={`/assets/${identy}`} className="btn btn-secondary mb-3 mt-3">← Back</Link>
        <h3 className='mt-3'>Edit asset</h3>
        <div>
          <LoadingBtn
            type="submit"
            text="Update"
            loading={loading}
            disabled={loading}
            onClick={() => formRef.current.submitForm()}
          />
        </div>
      </div>
      <div className="container" style={{ width: "900px", height: '450px', overflowY: 'auto' }}>
        <AssetForm ref={formRef} initialData={asset} onSubmit={handleEdit} isEdit={true} />
      </div>
    </>
  );
}

export default AssetEdit;